import { AnyIcon } from '@liveauctioneers/hammer-ui-core/icons/anyIcon';
import { BodyPrimary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode, useMemo } from 'react';

type AlertType = 'approved' | 'declined' | 'pending' | null;

type Props = {
    alertType: AlertType;
    className?: string;
    header: ReactNode;
    icon: AnyIcon;
    justify?: boolean;
    message?: ReactNode;
    noMargin?: boolean;
    testid?: string;
};

const RegistrationStatusMessage = ({
    alertType = null,
    className,
    header,
    icon: Icon,
    justify = false,
    message = '',
    noMargin = false,
    testid = 'registration-status-message',
}: Props) => {
    const styledIcon = useMemo(() => {
        switch (alertType) {
            case 'declined':
                return (
                    <Icon
                        color="critical"
                        size="sm"
                        style="fill"
                    />
                );

            case 'approved':
                return (
                    <Icon
                        color="success"
                        size="sm"
                        style="fill"
                    />
                );

            default:
                return (
                    <Icon
                        size="sm"
                        style="fill"
                    />
                );
        }
    }, [Icon, alertType]);

    return (
        <div
            className={cn(
                'mb-sm flex w-full max-w-[277px] flex-col items-center',
                {
                    'items-start': justify,
                    'mb-0': noMargin,
                },
                className
            )}
            data-testid={testid}
        >
            <div
                className={cn('mb-xs inline-flex items-center gap-2xs text-text-secondary', {
                    'items-start': justify,
                    'mb-0': noMargin,
                })}
            >
                <div
                    className={cn('h-[20px] w-[20px]', {
                        'mt-[2px]': justify,
                    })}
                >
                    {styledIcon}
                </div>
                <H5
                    className={cn('text-center uppercase text-text-secondary', {
                        'inline-flex text-text-critical': alertType === 'declined',
                        'text-success-700': alertType === 'approved',
                    })}
                >
                    {header}
                </H5>
            </div>
            <BodyPrimary className="text-center">{message}</BodyPrimary>
        </div>
    );
};

export default RegistrationStatusMessage;
